import { IconButton } from '@mui/material';
import { useState } from 'react';
import { DynamicIcon, Tooltip } from 'src/components';
import { PersonalizeSidePanelModal } from 'src/components/SidePanelPersonalization/PersonalizeSidePanelModal/personalize-side-panel-modal';
import { useGroupRules, UserGroupRules } from 'src/graphql';

// gated tune button + the shared modal; renders inside a
// SidePanelPersonalizationProvider, which supplies the surface
export const PersonalizeSidePanelButton = () => {
  const { checkValidity } = useGroupRules();
  const canPersonalize = checkValidity([UserGroupRules.AccessToPersonalizeSidepanel]);
  const [open, setOpen] = useState(false);

  if (!canPersonalize) {
    return null;
  }

  return (
    <>
      <Tooltip title="Personalize this view">
        <IconButton
          size="small"
          onClick={() => setOpen(true)}
          aria-label="Personalize this view"
        >
          <DynamicIcon name="tune" />
        </IconButton>
      </Tooltip>
      <PersonalizeSidePanelModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
